/**
 * El puerto de impresión.
 *
 * La Barra NO pregunta nunca en qué navegador está: pide una impresora y usa lo que
 * le den. En Bluefy le dan la de verdad; en Safari y en escritorio le dan una nula
 * y la interfaz de impresión sencillamente no se pinta. Gracias a eso la pantalla se
 * puede probar en Jest sin simular Bluetooth, y Kong no nota absolutamente nada.
 */
import { crearImpresoraBLE } from "./blePrinter";
import { haySoporteBLE } from "./soporte";

/** Sin Web Bluetooth no hay impresora, y decirlo no es un error: es el caso normal. */
function crearImpresoraNula() {
  return {
    disponible: false,
    observar: () => {},
    conectada: () => false,
    estadoPapel: () => null,
    conectar: async () => { throw new Error("Este navegador no puede conectarse a la impresora"); },
    reconectar: async () => null,
    imprimir: async () => { throw new Error("Este navegador no puede imprimir"); },
    desconectar: () => {},
  };
}

/**
 * UNA sola impresora por sesión del navegador.
 *
 * La conexión Bluetooth tiene que sobrevivir a que la Barra se monte y se desmonte:
 * antes se soltaba al salir de la pantalla, y volver obligaba a reconectar a mano.
 * En una barra eso es un toque cada vez que alguien navega, o sea, inaceptable.
 */
let instancia = null;

export function obtenerImpresora(opciones) {
  if (!instancia) instancia = haySoporteBLE() ? crearImpresoraBLE() : crearImpresoraNula();
  if (opciones) instancia.observar(opciones);
  return instancia;
}

/** Solo para los tests: cada caso arranca sin conexión heredada del anterior. */
export function olvidarImpresora() {
  instancia = null;
}

export { construirTicket } from "./ticket";
export {
  leerEmparejamiento, guardarEmparejamiento, olvidarEmparejamiento,
  yaImpresa, marcarImpresa, leerVistas, guardarVistas, leerEtiqueta, guardarEtiqueta,
  leerBaseImpresion, leerSueltasPendientes, guardarSueltasPendientes, guardarBaseImpresion,
} from "./emparejamiento";
export { haySoporteBLE } from "./soporte";
export * as estacion from "./estacion";
